<template>
  <div class="container-fluid py-3">
    <div class="d-flex align-items-center mb-3">
      <span class="mr-2" style="color:#9945FF; font-size:1.1rem; font-weight:700">Solana</span>
      <h5 class="mb-0 mr-3">Transaction History</h5>
      <router-link to="/solana" class="btn btn-sm btn-outline-secondary">← Wallet</router-link>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group input-group-sm">
          <input class="form-control" v-model="address" placeholder="Solana address" @keyup.enter="load" />
          <div class="input-group-append">
            <button class="btn btn-sm" style="background:#9945FF;color:#fff" @click="load" :disabled="loading">
              {{ loading ? 'Loading…' : 'Load' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <p class="text-muted small">Note: Shows up to 50 most recent transactions via Solana RPC.</p>
    <TxTable :txs="txs" :loading="loading" accent-color="#9945FF" />
  </div>
</template>

<script>
import TxTable from '../components/TxTable.vue';
import { fetchSolanaTxs } from '../services/txService';
import { Connection } from '@solana/web3.js';

export default {
  name: 'SolanaTransactions',
  components: { TxTable },
  data() { return { address: '', txs: [], loading: false }; },
  methods: {
    async load() {
      if (!this.address.trim()) return;
      this.loading = true;
      try {
        const conn = new Connection(`${window.location.origin}/solana-rpc/`);
        this.txs = await fetchSolanaTxs(this.address.trim(), conn, 50);
      } catch (e) { alert('Error: ' + e.message); }
      finally { this.loading = false; }
    },
  },
  mounted() {
    const w = this.$store && this.$store.state.wallets.solana;
    if (w && w.address) { this.address = w.address; this.load(); }
  },
};
</script>
